import * as PlaybackStateActions from "actions/PlaybackStateActions";
import { connect } from "react-redux";
import makeGetChapterEntity from "selectors/chapter/makeGetChapterEntity";
import MobileChapterNumbers from "components/MobileChapterControls/MobileChapterNumbers";
import { withRouter } from "react-router";
import { compose } from "recompose";
import getIsSubchapter from "selectors/getIsSubchapter";

const connector = connect(
  (state, ownProps) => ({
    financedUnlockedNavigationArrows:
      state.playerOptions.financedUnlockedNavigationArrows,
    showChapterNumber:
      !getIsSubchapter(state, ownProps) &&
      state.playerOptions.showChapterNumber,
    onChapterNextClick: (onDestroyPlaybackState) => {
      const currentChapterIndex = state.story.topLevelChapters.findIndex(
        ({ id }) => id === ownProps.chapterId,
      );
      if (currentChapterIndex >= state.story.topLevelChapters.length - 1) {
        // Can't go next
        return;
      }
      const nextChapterLink =
        state.story.topLevelChapters[currentChapterIndex + 1];
      const nextChapterEntity = makeGetChapterEntity()(state, {
        chapterId: nextChapterLink.id,
      });

      // TODO(router): This will change with react-router >v3
      ownProps.router.push({
        ...ownProps.location,
        pathname: [
          "",
          ownProps.params.routePrefix,
          state.route.params.storySlug,
          nextChapterEntity.slugs[0],
        ].join("/"),
      });

      onDestroyPlaybackState(`chapter-${nextChapterLink.id}`);
    },
    onChapterPreviousClick: (onDestroyPlaybackState) => {
      const currentChapterIndex = state.story.topLevelChapters.findIndex(
        ({ id }) => id === ownProps.chapterId,
      );
      if (currentChapterIndex <= 0) {
        // Can't go back
        return;
      }
      const nextChapterLink =
        state.story.topLevelChapters[currentChapterIndex - 1];
      const nextChapterEntity = makeGetChapterEntity()(state, {
        chapterId: nextChapterLink.id,
      });

      // TODO(router): This will change with react-router >v3
      ownProps.router.push({
        ...ownProps.location,
        pathname: [
          "",
          ownProps.params.routePrefix,
          state.route.params.storySlug,
          nextChapterEntity.slugs[0],
        ].join("/"),
      });

      onDestroyPlaybackState(`chapter-${nextChapterLink.id}`);
    },
  }),
  (dispatch) => ({
    dispatch,
    onDestroyPlaybackState: (stateKey) =>
      dispatch(PlaybackStateActions.destroyPlaybackState(stateKey)),
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onChapterNextClick() {
      stateProps.onChapterNextClick(dispatchProps.onDestroyPlaybackState);
    },
    onChapterPreviousClick() {
      stateProps.onChapterPreviousClick(dispatchProps.onDestroyPlaybackState);
    },
  }),
);

export default compose(withRouter, connector)(MobileChapterNumbers);
